import React, { Component } from 'react'
import { Header, Segment } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import CategoryActionButton from './categoryActionButton'
import AgGridTable from '../../agGridComponent/agGridTable'
import { connect } from 'react-redux'
import { categoryHeaders } from '../../../utils/constants/categories.constants'
import { tableHeaders,tableMessage } from '../../../utils/constants/table.constants'

import OnClickTitleBar from '../../titleBar/onClick_TitleBar'

import { getCategory } from '../../../redux/actions/categoryActions'
import { FEATURES } from '../../../utils/constants'

class CategoryTable extends Component {
    constructor(props){
        super(props)
        this.state = {
            isUpdated: false
        }

        this.getUpdate = this.getUpdate.bind(this)
    }

    componentDidMount(){
        this.props.getCategory()
    }

    getUpdate = (data) => {
        if (data) {
            this.setState({
                isUpdated: !this.state.isUpdated
            })
        }
    }

    render(){
        
        const { categories, isLoading } = this.props

        if(isLoading){
            return(
                <LoadingPlaceholder />
            )
        } else if ( categories && categories.length === 0 ){
            return (
                <React.Fragment>
                    <OnClickTitleBar title="Categories" LinkName="#" newPopup={this.props.newPopup} /> 
                    <Segment className='m-0'>
                        <center><Header>{tableMessage.NO_RECORD}</Header></center>
                    </Segment>
                </React.Fragment>
                    
            )
        } else {

            let columnDefs = [
                { headerName: categoryHeaders.CATEGORY_NAME, field: 'categoryName', tooltipField: 'categoryName', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: tableHeaders.CREATED_BY, field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: tableHeaders.CREATED_DATE, field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: tableHeaders.UPDATED_BY, field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: tableHeaders.UPDATED_DATE, field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
                { headerName: tableHeaders.EDIT_DELETE, field: 'edit', cellRenderer: 'actionRenderer' },

            ]
            let rowData = []
            categories && categories.map((object, index) => {
                let temp = {}
                temp.categoryName = object.categoryName
                temp.categoryId = object.categoryId
                temp.cby = object.createdByName
                temp.cdate = object.createdOn
                temp.uby = object.updatedByName
                temp.udate = object.updatedOn
                rowData[index] = temp
            })
            

            return (
                <React.Fragment>
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={this.props.searchValue}
                        actionButton={CategoryActionButton}
                        reload={this.getUpdate}
                        link="#"
                        hiddenNew={true}
                        newPopup={this.props.newPopup}
                        titleBarTitle="Categories"
                        handleSearch={this.props.handleSearch}
                        hiddenImportPopupBtn={true}
                        importLink=""
                        showImport={true}
                        fileName="psCategoryMaster"
                        importSubUrl={'masters/import/psCategoryMaster'}
                        exportHidden={FEATURES.mastersExportDisabled()}
                        suppressExcelExport={FEATURES.mastersExportDisabled()}
                        suppressCsvExport={FEATURES.mastersExportDisabled()}
                    />
                    
                </React.Fragment>
            )

        }
    }
}

const mapStatetoProps = (state) => ({
    categories: state.getCategories.categories ? state.getCategories.categories.resultSet : [],
    isLoading: state.getCategories.isLoading
})

export default connect(mapStatetoProps, { getCategory })(CategoryTable)